import Image from 'next/image'
import { useEffect, useState } from 'react'
import useEmblaCarousel from 'embla-carousel-react'
import Autoplay from 'embla-carousel-autoplay'

type Talent = {
  name: string
  title: string
  image: string
}

const TALENT: Talent[] = [
  {
    name: 'Prompt Engineers',
    title: 'AI & Product Engineering',
    image: '/assets/inc/talent/prompt_engineers.png'
  },
  {
    name: 'Product Managers',
    title: 'AI & Product Engineering',
    image: '/assets/inc/talent/product_manager.png'
  },
  {
    name: 'Strategists',
    title: 'Creative & Content Intelligence',
    image: '/assets/inc/talent/strategist.png'
  },
  {
    name: 'Editors',
    title: 'Creative & Content Intelligence',
    image: '/assets/inc/talent/editors.png'
  },
  {
    name: 'Solution Architects',
    title: 'Platform Integration',
    image: '/assets/inc/talent/solution_architect.png'
  },
  {
    name: 'Automation Engineers',
    title: 'Platform Integration',
    image: '/assets/inc/talent/automation_engineer.png'
  },
  {
    name: 'Program Manager',
    title: 'Account & Delivery',
    image: '/assets/inc/talent/program_manager.png'
  },
  {
    name: 'Customer Success Lead',
    title: 'Account & Delivery',
    image: '/assets/inc/talent/customer_success.png'
  }
]

export const TalentCarousel = () => {
  const [emblaRef, emblaApi] = useEmblaCarousel(
    {
      loop: true,
      align: 'start',
      containScroll: 'trimSnaps'
    },
    [Autoplay({ delay: 3000, stopOnInteraction: false })]
  )
  const [selected, setSelected] = useState(0)

  useEffect(() => {
    if (!emblaApi) return
    const onSelect = () => setSelected(emblaApi.selectedScrollSnap())
    emblaApi.on('select', onSelect)
    onSelect()
    return () => {
      emblaApi.off('select', onSelect)
    }
  }, [emblaApi])

  const scrollTo = (index: number) => emblaApi?.scrollTo(index)

  return (
    <div className="space-y-6 -mx-4 md:-mx-8 px-4 md:px-8">
      <div className="overflow-hidden" ref={emblaRef}>
        <div className="flex gap-6">
          {TALENT.map(person => (
            <div
              key={person.name}
              className="flex-[0_0_calc(75%-1rem)] md:flex-[0_0_calc(45%-1rem)] lg:flex-[0_0_calc(33.333%-1rem)] xl:flex-[0_0_calc(25%-1rem)] space-y-3 min-w-0"
            >
              <div className="relative w-full aspect-4/3 rounded-3xl overflow-hidden">
                <Image
                  src={person.image}
                  alt={person.name}
                  fill
                  className="object-contain"
                />
              </div>
              <div className="space-y-1 px-1">
                <p className="text-xs uppercase tracking-wide text-[#4B5563]">
                  {person.title}
                </p>
                <p className="text-lg font-semibold leading-6 text-[#0F172A]">
                  {person.name}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="flex items-center justify-center gap-2">
        {TALENT.map((_, index) => (
          <button
            key={index}
            onClick={() => scrollTo(index)}
            aria-label={`Go to slide ${index + 1}`}
            className={`w-2 h-2 rounded-full transition-all ${
              selected === index ? 'bg-black' : 'border border-black'
            }`}
          />
        ))}
      </div>
    </div>
  )
}
